import login from './login';
import route from './route';
import common from './common';
import layout from './layout';
import stuManagement from './student_management';
import validate from './validate';
import message from './message';
import insInfo from './institution_info';
import insInfoSearch from './institution_info_search';
import mps from './mps';
import company from './company';
import tagsView from './tagsView';
import popupNotice from './popup_notice';

export default {
  index: {
    countryDistributionPieTitle: '学生申请意向国家分布',
    nowStudentCount: '{year}学生数',
    nowReadingCount: '{year}{text}',
    allStudentCount: '全部学生数',
    allReadingCount: '全部{text}',
    enrolledSuccessProportion: '成功率',
    studentTotalSum: '学生数（申请数）',
    enrolledSuccess: '成功入读数',
    enrollment: '成功入读数',
    applicationCountBarTitle: '申请学生数/{text}',
    applyCount: '申请数',
    goProScore: 'GoPro积分',
    successfulEnrolment: '入学成功数',
    studentCount: '学生数',
    enrolment: '入学数',
    applyStatus: '申请状态',
    successfulContract: '入学学生数',
    studentOverview: '学生总览',
    studentQuery: '学生查询',
    studentQueryList: '学生查询列表',
    applicationList: '申请列表',
    addStudent: '新增学生',

    pending: "未申请",
    stepNewAppCount: '新申请',
    submitted: '已提交',
    stepFailureCount: '未录取',
    admittedOffer: '已录取',
    paid: '已缴费',
    enrolled: '已入学',
    stateUpdate: '状态更新',
    studentOffer: '学生申请',
    consultant: '顾问',
    studentPage: '学生专页',
    returnStudentPage: '返回学生专页',
    newApplication: '新增申请',
    gmtCreate: '创建日期',
    gmtModified: '更新日期',
    application: '申请',
    stepDepositPaidCount: '付定(费)',
    stepOfferSelectionCount: '签证函',
    stepVisaGrantedCount: '签证',
    stepEnrolledCount: '入学',
    stepPayPremiumCount: '付佣',
    nationality: '国籍/地区',
    nationalityPassport: '护照国籍/地区',
    passport: '护照',
    passportFrom: '护照国籍/地区',
    birthday: '生日',
    startDate: '开始日期',
    endDate: '结束日期',
    level: '级别',
    course: '课程',
    accommodation: '住宿',
    airportPickup: '接机',
    need: '需要',
    noNeed: '不需要',
    schoolType: '级别',
    school: '学校',
    courseApply: '课程申请',
    applyDetail: '申请详细',
    applyContentForm: '申请内容表单',
    personalProfile: '个人资料',
    educationalBackground: '教育背景',
    educationBackground: '学历背景',
    personalBackground: '个人背景',
    referrer: '推荐人 {num}',
    workExperience: '工作经验',
    professionalQualification: '专业资格',
    applyAttachment: '申请附件',
    addAttachment: '新增附件',
    packWord: '打包成WORD',
    packDownloadAllFile: '打包并下载全部文件',
    applicant: '申请人',
    applicantData: '申请人资料',
    applyId: '申请ID',
    studyCountry: '升学国家/地区',
    studyCountryRegion: '升学国家/地区',
    institutionName: '院校名称',
    institution: '院校',
    attachment: '附件',
    applyNo: '申请编号',
    statusUpdateDate: '状态更新日',
    processingDays: '处理天数',
    applyStatusAttachment: '申请状态附件',
    stepNotes: '步骤备注',
    examType: '考试类型',
    want: '想',
    notWant: '不想',
    ieltsType: 'IELTS 类型',
    examTotal: '总分',
    examListen: '听',
    examRead: '读',
    examWrite: '写',
    examSpeak: '说',
    testCenterNumber: '测试中心号码',
    examinationDate: '考试日期',
    examinationNumber: '考生号码',
    examinationCheckAccount: '查询账号',
    isReexamination: '会否重考',
    englishExamRecord: '英语考试成绩',
    allAttachment: '所有附件',
    uploadDate: '上传日期',
    fileName: '文件名',
    attachmentTips: '(提交后不能重新上传/删除)',
    under18GuardianContact: '18岁以下的监护人联络方式',
    contact: '联络',
    fatherName: '父亲姓名',
    motherName: '母亲姓名',
    mobileOrTel: '手机/电话号码',
    agentContact: '代理联络',
    agentMobileOrTel1: '手机/电话 1',
    agentMobileOrTel2: '手机/电话 2',
    agentMobileOrTel3: '手机/电话 3',
    agentEmail1: '电邮 1',
    agentEmail2: '电邮 2',
    agentEmail3: '电邮 3',
    furtherInformation: '背景资料',
    studyCountryLearning: '升学国家/地区学习',
    religion: '宗教信仰',
    isVisaRefused: '曾被拒签国家/地区',
    isDisability: '残疾或特殊需求',
    isEnglishMotherLanguage: '英语是你的第一语言',
    isStudyInEnglish: '修读过英语为授课语言的高中或以上',
    enrolledSchool: '入读院校{index}',
    uploadFile: '上传文件',
    typeOfInstitution: '院校类别',
    address: '地址',
    major: '主修',
    studyStartDate: '在校开始日期',
    studyEndDate: '在校结束日期',
    studyInEnglish: '英语教学及考试',
    scoreOrTotal: '分数/总分',
    isCompleted: '完成学习',
    isShouldCompleted: '将会完成',
    studyAndExamInEnglish: '以英语为教学和考试语言',
    studyInEnglishNotExam: '以英语为教学语言但不包括考试',
    secondaryCourses: '中学课程',
    universityOrAboveCourses: '大学以上课程',
    qualificationName: '资格名称',
    qualificationGroup: '认证机构',
    qualificationRegion: '认证国家/地区',
    qualificationGrade: '评分级别（如适用）',
    qualificationStartDate: '课程开始日期',
    qualificationGetDate: '预计或获得资格日期',
    qualificationGetStatus: '获得资格状态',
    inProgress: '进行中',
    acquired: '已获得',
    workExperienceTips: '最小号码为最近工作',
    companyName: '单位名称',
    position: '职位',
    workMode: '全职/业余',
    fullTime:'全职',
    partTime: '业余',
    workStartDate: '在职开始日期',
    workEndDate: '在职结束日期',
    isOnDuty: '目前是否在职',
    jobDescription: '职责描述',
    companyAddress: '单位地址',
    institutionOrCompany: '院校/公司',
    contactAddress: '联系地址-(机构/个人)',
    postcode: '邮政编码',
    name: '姓名',
    openTimeStart: '开学开始日期',
    openTimeEnd: '开学结束日期',
    statusBeginTime: '状态开始日期',
    statusEndTime: '状态结束日期',
    statusTimeRange: '状态日期',
    statusDays: '状态天数',
    submitStartTime: '提交开始日期',
    submitEndTime: '提交结束日期',
    createStartTime: '创建开始日期',
    createEndTime: '创建结束日期',
    openingTime: '开学日期',
    updateTime: '更新日期',
    submitTime: '提交日期',
    submitter: '提交人',
    days: '天数',
    applicationCountry: '申请国家/地区',
    commission: '佣金',
    dataCategory: '数据类别',
    total: '总数',
    distribution: '分布情况',
    yearCommission: '年度佣金',
    receivedCommission: '已收佣金',
    unrealizedCommission: '未实现佣金',
    commissionRemark1: '佣金-以学生入学年份计算的预计佣金',
    commissionRemark2: '入学数-以学生入学年份计算年份',
    commissionRemark3: '申请数-以申请创建日计算年份',
    commissionRemark4: '学生数-以创建学生日计算年份',
    overview: '总览',
    all: '所有',
    settleable: '可结算',
    unsettled: '未结算',
    settling: '结算中',
    received: '已结算/已收款',
    applicationDistribution: '申请分布',
    countryDistribution: '国家分布',
    institutionsDistributionQSRanking: '院校QS排名分布',
    top9: '申请学校TOP9',
    subjectDistribution: '专业分布',
    offerItemCommission: '留学申请',
    serviceFeeCommission: '留学服务费',
    insuranceCommission: '留学保险',
    accommodationCommission: '留学住宿',
    differentialSubmission: '差异提交',
    submitSettlement: '提交结算',
    totalCommission: '总佣金',
    currency: '货币',
    tuition: '学费',
    commissionRatio: '佣金比例',
    splitRate: '分成比例',
    paidAmount: '已收金额',
    theReceivable: '本次应收',
    auditOpinion: '审核意见',
    proposeDifference: '提出差异',
    insuranceAmount: '保险金额',
    receivableAmount: '应收金额',
    apartmentName: '学生公寓',
    checkInTime: '入住时间',
    checkInDays: '入住天数',
    payableCommission: '应结佣金',
    currencyType: '货种',
    type: '类型',
    checkStatement: '核对账单',
    eSignature: '电子签名',
    downloadStatement: '备份对账单',
    previewStatement: '预览对账单',
    rolledBack: '对账单已被回退，点击查看原因！',
    chineseAccoountTips: '如提供的银行账户是中文账户信息，默认为统一用人民币结算',
    englishAccoountTips: '如提供的银行账户是英文账户信息，默认为用外币结算',
    statementTips1: '外币结算，需代理提供境外外币账户(香港汇丰优先)，人民币计算，汇款需通过跨境换汇支付',
    statementTips2: '于结算月中旬导单，合作方收到佣金单后建议3天内(最迟当月20日前)回签确认',
    statementTips3: '收到合作方回签确认后，月底至次月中完成汇款',
    statementTips4: '由于跨境汇款限制流程复杂，合作方需在7天内回复是否到账，超出7天后提出未到账将不予受理',
    statementTips5: '请确保银行信息(包括支行)准确，如因账户错误导致退款所产生手续费由贵公司承担',
    statementTips6: '汇款参考统一港币对照汇款当日香港中国银行早上10点现钞买入价换汇人民币结算',
    statementTips7: '院校每次结算时会产生每笔5-8%不等的中间银行操作手续费，GEA对代理结算(含预付款)时将统一每笔扣除5元本币种的金额',
    unsettledSubmitTips1: '我们已经开始对您提交的所有账单进行审核，我们将尽快与您取得联系，请注意查收邮件。',
    unsettledSubmitTips2_1: '如有任何问题，请',
    unsettledSubmitTips2_2: '联系',
    unsettledSubmitTips2_3: '负责的',
    unsettledSubmitTips2_4: '区域经理',
    unsettledSubmitTips3: '您有负账单未确认勾选！',
    submitAndESign: '提交并签名',
    addSubmit: '添加提交',
    bankAccount: '银行账户',
    bankAccountSelect: '请选择银行账户',
    settleMethod: '结算方式',
    differentCurrency: '不同货币结算',
    unifiedCurrency: '统一货币结算',
    settleCurrency: '结算币种',
    originCurrency: '原币种',
    transactionDate: '交易日期',
    limitFileSize: '上传文件大小不能超过20M',
    uploadDragTips: '将文件拖到此处，或',
    uploadDragTips2: '点击上传',
    uploadESigned: '电子签署文件上传',
    uploadedStatement: '已上传的对账单',
    uploadStatementTips: '请上传对账单',
    receivedTips: '仅显示最近半年的数据',
    uploadSuccess: '上传成功！',
    exportNoDataTips: '当前搜索条件无数据可导出！',
    editStudentInfo: '编辑学生信息',
    addApplyCourse:'加申课程',
    studentUnit: '人',
    noDataSettlingTips: '暂无结算中数据，请先提交结算！',
    hasSettlingCommissionTips: '你有结算中的佣金，需要等待上一次结算完成后才能继续提交新的结算。上一次提交时间：{time}',
    differentialSubmissionQuestionTips: '如果您对佣金有疑问，可以点击此按钮进行反馈，我们会重新为您审核。',
    noSearchResults: "未搜索到相关数据！",
    totalProportion: "占比总数",
    submitSettlementTips: '您填写完信息还未点击按钮提交结算，确定离开吗？',
    bmsMaskTips: '您的佣金结算已由 BD 在 BMS 系统中处理。如需改为 GEAR 结算，请联系您的 BD：',
    signedSucc: '入学登记完成',
    totleStudent: "总学生数",
    welcomeBack: '欢迎回来',
    unsettledDesc: "您可以在此步骤提交结算， 如有疑问请差异提交",
    settlingDesc: "您提交的结算的账单可在此页面查看并上传对账单",
    receivedDesc: "已完成结算汇款",
    settlementProcessStatus: "结算流程状态",
    studentEmailTips: "此学生的邮件已存在，如同时提交同一个学生的申请，仅有一名代理获得佣金。",
    noSignature: '还未进行签名确认',
    eSignatureTips1: '请提前准备好相关',
    eSignatureTips1_1: '电子签名',
    eSignatureTips1_2: '和',
    eSignatureTips1_3: '公司电子印章',
    eSignatureTips1_4: '进行上传。',
    companySealUpload: '公司印章上传',
    eSignatureUpload: '电子签名上传',
    uploadESignature: '上传电子签名',
    uploadCompanySeal: '上传公司印章',
    settlementConfirmation: '确认结算',
    eSignatureTips2: "您还未完成电子签名并",
    eSignatureTips2_1: "确认结算",
    eSignatureTips2_2: "，确定离开吗？",
    fileSizeTips: "（建议：文件大小最好控制在2M以内。）",
    comparisonRecord: "对比记录",
    commissionSettledTips: '每月{start}号至{end}号为结算佣金日期，请在该时间段内结算您的佣金',
    ifApplicable: '如有',
    eSignatureTips3_1: "没有电子签名？",
    eSignatureTips3_2: '点击进行手绘生成',
    handwrittenSignature: '手绘签名',
    clearSignature: '清除签名',
    confirmandBackup: '确认',
    eSignatureTips4_1: "请使用",
    eSignatureTips4_2: '参考示例字体大小',
    eSignatureTips4_3: '进行签名，如签名字体过小或者不清晰可能会要求重签，这样可能会影响结算进度。',
    eSignatureTips5_1: '请确保签名图片',
    eSignatureTips5_2: '笔迹清晰可辩背景透明',
    eSignatureTips5_3: '，如使用公司印章，请确保印章清晰。',
    eSignatureTips6_1: '请预览检查合成电子签署后的对账单，没有问题则',
    eSignatureTips6_2: '点击确认结算',
    eSignatureTips7: '请先签名！',
    pleaseEnterRemark: '请输入备注',
    currentStatisticsTips:'*当前统计{year}年的最新数据',
  },
  login,
  route,
  common,
  message,
  ...layout,
  stuManagement,
  validate,
  insInfo,
  insInfoSearch,
  mps,
  company,
  tagsView,
  popupNotice,
};
